import React from "react";
import { renderToStaticMarkup } from 'react-dom/server';
import fsiLogo from '@/Assets/fsi-logo 3.png'
import WideTemplate from "../Private/WideTemplate";
import PageTitleTemplate from "@/Components/FSI/Templates/page-title-template";
import Card from "@/Components/Surface/Card";
import { Accordion, AccordionDetails } from "@/Components/Surface/Accordion";
import Checkbox from "@/Components/Inputs/Checkbox";
import { getDeliveryDetailsbyId } from "@/Services/delivery_services";
import LoadingDialog from "@/Components/Feedback/LoadingDialog";
import Stack from "@/Components/DataDisplay/Stack";
import Button from "@/Components/Inputs/Button";
import {Link} from 'react-router-dom'

import { toFSIDatetimeFormat } from "@/Helpers/timezones";

import { jsPDF } from "jspdf";
import NoSignatureProvided from "@/Icons/NoSignatureProvided";
import NoPhotoProvided from "@/Icons/NoPhotoProvidedIcon";

const SignatureImage = ({ signatureImage }) => {

    return (
        <div className='rounded w-fit flex items-center p-3 justify-center border border-grey-1'>
            <img className=' w-[143px] h-[55px]' alt="signature" src={`data:image/bmp;base64,` + signatureImage} />
        </div>
    )

}
const CardItems = ({ items, className, title }) => {

    if (!items) return null

    return (
        <div className={`${className} w-[227px] h-fit border-[0.5px] border-b-0 rounded-t-[3.5px] border-grey-6`}>
            <h1 className=' min-h-[39px] text-center text-black font-semibold text-14  py-[7px] bg-purple-2 rounded-t-[3px] border-t-[0.5px] border-b-[0.5px]'>{title}</h1>
            {items?.map((items, idx) => {
                return <div key={idx} className='p-3 border-b-[0.5px] border-grey-6'>
                    <div className='text-12 text-black font-normal truncate  '>
                        {items}
                    </div>
                </div>
            })}
        </div>
    )
}

const DeliveryDetailsItems = ({ className, name, children }) => {
    return (
        <div className={` ${className} w-full h-[25px] justify-start items-center gap-3 inline-flex`}>
            <div className="text-xs font-semibold ">{name}</div>
            <div className="text-xs font-normal leading-normal">{children}</div>
        </div>
    )
}

const bufferToBase64 = (arrayBuffer) => {
    let binary = '';
    const bytes = new Uint8Array(arrayBuffer);
    const length = bytes.length;
    for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

class PODDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingDialogOpen: true,
            CommercialShipper: {},
            City: '',
            CompanyName: '',
            ContactPhone: '',
            Complete: false,
            Contact: "",
            InvoiceNumber: '',
            Routes: '',
            CustomerLongPO: null,
            CustomerPO: null,
            DeliveryDate: "",
            DeliveryId: "",
            DeliveryLocation: "",
            DeliveryPackages: [],
            DeliveryTypeId: null,
            DriverAlert: false,
            DriverComments: "",
            ForcedComplete: false,
            ImageUrl: "",
            ImportDate: "",
            Manifest: null,
            MobileCreate: false,
            NoteId_DriverNotes: [],
            PackageCount: null,
            RecipientPrintedName: "",
            RecipientSignature: {},
            Route: "",
            Sequence: "",
            SpecialInstructions: "",
            State: "",
            Street: "",
            ZipCode: "",
            rowguild: null,
            PieceCountNote : [],
            canLoadProofOfDeliveryImage : true
        };
    }

    renderPdfContent = () => {
        const {
            DeliveryId,
            InvoiceNumber,
            Contact,
            Manifest,
            ContactPhone,
            Route,
            CompanyName,
            Street,
            City,
            State,
            ZipCode,
            CustomerPO,
            CustomerLongPO,
            SpecialInstructions,
            Complete,
            DeliveryDate,
            RecipientPrintedName,
            RecipientSignature,
            PackageCount,
            CommercialShipper
        } = this.state;

        return renderToStaticMarkup(
            <div className="font-['Times_New_Roman'] w-full p-[30px]">
                <div className="w-full mb-[15px]">
                    <p className="text-[12px]">FSI Office - Delivery Receipt</p>
                    <p className="text-[14px] font-bold">
                        6410 Orr Rd
                        <br />
                        Charlotte, NC 28213
                        <br />
                        800-532-0335
                        <br />
                        800-635-9968 fax
                    </p>
                </div>
                <p className="font-bold underline text-[14px] mb-[15px]">Delivery Id: {DeliveryId} Delivery</p>
                <table className="text-[14px] mb-[15px] w-full">
                    <tr>
                        <td className="font-bold">Invoice:</td>
                        <td className="text-purple-1">{InvoiceNumber}</td>
                        <td className="font-bold">Contact:</td>
                        <td className="text-purple-1">{Contact}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Manifest:</td>
                        <td className="text-purple-1">{Manifest}</td>
                        <td className="font-bold">Phone:</td>
                        <td className="text-purple-1">{ContactPhone}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Route:</td>
                        <td className="text-purple-1">{Route}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Company:</td>
                        <td colSpan={3} className="text-purple-1">{CompanyName}</td>
                    </tr>
                    
                    <tr>
                        <td className="font-bold">Street:</td>
                        <td colSpan={3} className="text-purple-1">{Street}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">City:</td>
                        <td className="text-purple-1">{City}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">State:</td>
                        <td className="text-purple-1">{State}</td>
                        <td className="font-bold">ZipCode:</td>
                        <td className="text-purple-1">{ZipCode}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Customer PO:</td>
                        <td colSpan={3} className="text-purple-1">{CustomerPO}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Long PO:</td>
                        <td colSpan={3} className="text-purple-1">{CustomerLongPO}</td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <hr className="border-[1px] border-black mt-[10px]" />
                        </td>
                    </tr>
                    <tr>
                        <td className="font-bold">Special Instructions:</td>
                        <td colSpan={3} className="text-purple-1">{SpecialInstructions}</td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <hr className="border-[1px] border-black mt-[15px]" />
                        </td>
                    </tr>
                    <tr>
                        <td className="font-bold">Complete</td>
                        <td className="relative">
                            <input type="checkbox" className="absolute" checked={Complete} />
                        </td>
                    </tr>
                    <tr>
                        <td className="font-bold">Delivery Date:</td>
                        <td className="text-purple-1">{DeliveryDate && toFSIDatetimeFormat(DeliveryDate)}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Printed Name:</td>
                        <td className="text-purple-1">{RecipientPrintedName}</td>
                    </tr>
                    <tr>
                        <td className="font-bold">Signature:</td>
                    </tr>
                </table> 
                {RecipientSignature &&  
                <div className="w-fit border-2 border-black p-[2px] mb-[5px]">
                    <div className="border border-black p-[1px]">
                        <img className="w-[170px] h-[100px] border border-black" alt="Signature" src={`data:image/bmp;base64,${RecipientSignature}`} />
                    </div>
                </div>
                }
                {!RecipientSignature && <p className="text-red">Signature not available</p>}
                <div className="text-[14px] mb-[20px] w-full">
                    <p className="font-bold underline">Packages:</p>
                    <table>
                        <tr>
                            <td className="font-bold">Ordered Quantity:</td>
                            <td className="text-purple-1">{PackageCount}</td>
                        </tr>
                        <tr>
                            <td className="font-bold">Delivered Quantity:</td>
                            {/* TODO: Bind value for Delivered Quantity */}
                            <td className="text-purple-1"></td>
                        </tr>
                    </table>
                </div>
                <div className="text-[14px] w-full">
                    <table>
                        <tr>
                            <td className="font-bold">Commercial Shipper Tracking #:</td>
                            <td className="text-purple-1">{CommercialShipper?.TrackingNumber}</td>
                        </tr>
                        <tr>
                            <td className="font-bold">Ship Via:</td>
                            <td className="text-purple-1">{CommercialShipper?.ShipVia}</td>
                        </tr>
                    </table>
                </div>
            </div>
        );
    };

    handlePrintDeliveryReceiptClick = () => {
        const deliveryId = decodeURIComponent(this.props.match.params?.deliveryId);

        const doc = new jsPDF({
            unit: 'px',
            format: 'letter',
            hotfixes: ['px_scaling']
        });
        const width = doc.internal.pageSize.getWidth();

        doc.setProperties({
            title: deliveryId
        });
        doc.autoPrint();
        doc.html(this.renderPdfContent(), {
            callback: doc => {
                doc.output('dataurlnewwindow', {
                    filename: `${deliveryId}.pdf`
                });
            },
            width,
            windowWidth: width
        });
    };

    componentDidMount() {
        try {
            this.setState({
                isLoadingDialogOpen: true,
            }, async () => {
                try {
                    const deliveryId = decodeURIComponent(this.props.match.params.deliveryId);
                    const response = await getDeliveryDetailsbyId(deliveryId);

                    const { DeliveryId,
                        ImageUrl,
                        CommercialShipper,
                        City,
                        CompanyName,
                        ContactPhone,
                        Complete,
                        Contact,
                        InvoiceNumber,
                        Manifest,
                        Routes,
                        CustomerLongPO,
                        CustomerPO,
                        DeliveryDate,
                        DeliveryLocation,
                        DeliveryPackages,
                        DeliveryTypeId,
                        DriverAlert,
                        DriverComments,
                        ForcedComplete,
                        ImportDate,
                        MobileCreate,
                        NoteId_DriverNotes,
                        PackageCount,
                        RecipientPrintedName,
                        RecipientSignature,
                        Route,
                        Sequence,
                        SpecialInstructions,
                        State,
                        Street,
                        ZipCode,
                        rowguild,
                        PieceCountNote } = response;

                    this.setState({
                        isLoadingDialogOpen: false,
                        DeliveryId,
                        ImageUrl,
                        City,
                        CompanyName,
                        ContactPhone,
                        Complete,
                        Contact,
                        CommercialShipper: CommercialShipper ? CommercialShipper : null,
                        InvoiceNumber,
                        Manifest,
                        Routes,
                        CustomerLongPO,
                        CustomerPO,
                        DeliveryDate,
                        DeliveryLocation,
                        DeliveryPackages: DeliveryPackages ? DeliveryPackages : null,
                        DeliveryTypeId,
                        DriverAlert,
                        DriverComments,
                        ForcedComplete,
                        ImportDate,
                        MobileCreate,
                        NoteId_DriverNotes,
                        PackageCount,
                        RecipientPrintedName,
                        RecipientSignature: RecipientSignature ? bufferToBase64(RecipientSignature.data) : null,
                        Route,
                        Sequence,
                        SpecialInstructions,
                        State,
                        Street,
                        ZipCode,
                        rowguild,
                        PieceCountNote
                    });

                } catch (error) {
                    console.log('error',error)
                } finally {
                    this.setState({
                        isLoadingDialogOpen: false
                    })
                }
            });
        } catch (error) {
            return Promise.reject(error);
        }
    }

    handleProofOfDeliveryImageError = () => {
        this.setState({
            canLoadProofOfDeliveryImage : false
        })
    }

    render() {
        const { isLoadingDialogOpen,
            ImageUrl,
            CommercialShipper,
            City,
            CompanyName,
            ContactPhone,
            Complete,
            InvoiceNumber,
            Manifest,
            CustomerLongPO,
            CustomerPO,
            DeliveryDate,
            DeliveryPackages,
            DriverAlert,
            DriverComments,
            ForcedComplete,
            MobileCreate,
            PackageCount,
            RecipientPrintedName,
            RecipientSignature,
            Route,
            State,
            Street,
            ZipCode,
            PieceCountNote,
            canLoadProofOfDeliveryImage } = this.state;

        return (
            <div className="flex flex-col min-h-screen bg-grey-2">
                <div className="pod-header w-full flex items-center justify-center h-24 bg-white shadow">
                <Link to={'/pod'}>
                <img src={fsiLogo} className='w-[131px] h-[55px]' alt="fsi" />
                </Link>

            </div>
            <WideTemplate>
                <LoadingDialog isOpen={isLoadingDialogOpen} />
                <Stack>
                    <PageTitleTemplate title="Delivery Details" />
                    <Stack className="gap-[16px] mb-6">
                        {/* <Button className="w-[107px]">Send as Email</Button> */}
                        <Button className="w-[159px]" onClick={this.handlePrintDeliveryReceiptClick}>Print Delivery Details</Button>
                    </Stack>
                </Stack>
                <div className="flex flex-col gap-6">
                    <Card className='p-8'>
                        <div className="text-base font-semibold mb-6">Delivery ID: {decodeURIComponent(this.props.match.params.deliveryId)}</div>
                        <div className="flex gap-8 items-start">
                            <div className="flex flex-col w-1/3 gap-2">
                                <DeliveryDetailsItems name="Invoice:" >{InvoiceNumber}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="Manifest:">{Manifest}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="Route:">{Route}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="Company Name:">{CompanyName}</DeliveryDetailsItems>

                            </div>
                            <div className="flex flex-col w-1/3 gap-2">
                                <DeliveryDetailsItems name="Street:">{Street}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="City:">{City}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="State:">{State}</DeliveryDetailsItems>
                            </div>
                            <div className="flex flex-col w-1/3 gap-2">
                                <DeliveryDetailsItems name="Customer P.O:">{CustomerPO}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="Long P.O:">{CustomerLongPO}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="ZIP Code:">{ZipCode}</DeliveryDetailsItems>
                                <DeliveryDetailsItems name="Phone Number:">{ContactPhone}</DeliveryDetailsItems>
                            </div>
                        </div>
                    </Card>
                    <Accordion title='Special Instruction' className='bg-white h-fit'>
                        <AccordionDetails className="h-full">
                            <div className=" flex flex-col  space-y-2">
                                <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Complete:</p>
                                    <Checkbox disabled checked={Complete}></Checkbox>
                                </div>
                                <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Delivery Date:</p>
                                    <p className="text-xs font-normal leading-normal">{DeliveryDate && toFSIDatetimeFormat(DeliveryDate)}</p>
                                </div>

                                <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Printed Name:</p>
                                    <p className="text-xs font-normal leading-normal">{RecipientPrintedName}</p>
                                </div>
                                <div className="w-full justify-start h-25 space-y-[10px] flex-col">
                                    <p className="text-xs w-[114px] font-semibold">Signature</p>
                                    {RecipientSignature ? <SignatureImage signatureImage={RecipientSignature} ></SignatureImage> : <NoSignatureProvided/>}
                                </div>
                                <div className="w-full justify-start h-25 mt-3 space-y-[10px] flex-col">
                                    <p className="text-xs font-semibold">Proof of Delivery Photo</p>
                                    {!isLoadingDialogOpen && ImageUrl  && canLoadProofOfDeliveryImage &&                                         
                                        <img
                                            onError={this.handleProofOfDeliveryImageError}
                                            className="border border-grey-1 rounded object-scale-down h-96 w-96"
                                            alt="signature" src={ImageUrl}
                                        />}
                                    {!isLoadingDialogOpen && (!ImageUrl || !canLoadProofOfDeliveryImage)  && <NoPhotoProvided/>}
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion title='Delivery Packages' className='bg-white h-fit'>
                        <AccordionDetails>
                            <div className="flex space-x-3">
                                <div className="flex flex-col w-fit space-y-4">
                                    <div className="flex space-x-2">
                                        <p className="text-xs font-normal leading-normal">Ordered Quantity:</p>
                                        <p className="text-xs font-normal leading-normal">{PackageCount}</p>
                                    </div>
                                    <CardItems title="Package ID" items={DeliveryPackages?.map(item => item.DeliveryId)}></CardItems>
                                </div>
                                <div className="flex flex-col w-fit space-y-4">
                                    <div className="flex space-x-2">
                                        <p className="text-xs font-normal leading-normal">Delivery Quantity:</p>
                                        <p className="text-xs font-normal leading-normal">{DeliveryPackages?.length}</p>
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion title='Driver Notes' className='bg-white h-fit'>
                        <AccordionDetails className="h-full">
                            <div className=" flex flex-col  space-y-2">
                                {/* <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Driver:</p>
                                    <p className="text-xs font-normal leading-normal"></p>
                                </div> */}
                                <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Comments:</p>
                                    <p className="text-xs font-normal leading-normal">{DriverComments}</p>
                                </div>
                                <div className="w-full h-[25px] justify-start items-center gap-3 inline-flex">
                                    <p className="text-xs w-[114px] font-semibold">Driver Alert:</p>
                                    <Checkbox disabled checked={DriverAlert}></Checkbox>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion title='Commercial Shipper Information' className='bg-white h-fit'>
                        <AccordionDetails className="h-full">
                            <div className="flex w-full">
                                <div className="flex flex-col w-1/3 gap-2">
                                    <DeliveryDetailsItems name="Ship Date:">{CommercialShipper?.ShipDate && toFSIDatetimeFormat(CommercialShipper?.ShipDate)}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Tracking #:">{CommercialShipper?.TrackingNumber}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Mode:">{CommercialShipper?.Mode}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="COD:">{CommercialShipper?.COD}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Customer #:">{CommercialShipper?.CustomerNumber}</DeliveryDetailsItems>

                                </div>
                                <div className="flex flex-col w-1/3 gap-2">
                                    <DeliveryDetailsItems name="Ship Via:">{CommercialShipper?.ShipVia}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Weight:">{CommercialShipper?.Weight}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Freight:">{CommercialShipper?.Freight}</DeliveryDetailsItems>
                                    <DeliveryDetailsItems name="Department #:">{CommercialShipper?.Department}</DeliveryDetailsItems>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion title='Additional Information' className='bg-white h-fit'>
                        <AccordionDetails className="h-full">
                            <div className=" flex space-x-4 flex-start w-full">
                                <div className=" h-[25px] justify-start items-center gap-3 inline-flex">
                                    <Checkbox disabled checked={MobileCreate} ></Checkbox>
                                    <p className="text-xs w-[114px] font-semibold">Mobile Create</p>
                                </div>
                                <div className="h-[25px] justify-start items-center gap-3 inline-flex">
                                    <Checkbox disabled checked={ForcedComplete} ></Checkbox>
                                    <p className="text-xs w-[114px] font-semibold">Force Complete</p>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion title='Piece Count Changes Notes' className='bg-white h-fit'>
                        <AccordionDetails className="h-full">
                            {PieceCountNote?.map(({NoteText}, index) => {
                                return <DeliveryDetailsItems key={index} name="Note:">{NoteText}</DeliveryDetailsItems>
                            })}
                        </AccordionDetails>
                    </Accordion>
                </div>

            </WideTemplate>
            </div>
            
        )
    }
}



export default PODDetails;